export const openUrlInNewTab = (url: string) => {
  // TODO: Remove setTimeout once fixed https://github.com/facebook/react/issues/17355
  setTimeout(() => window.open(url));
};
